import siteMaintenance from "./siteMaintenance";
import assetManager from "./assetManager";
import objectManager from "./objectManager";
import pid from "./pid";
import modelViewer from "./modelViewer";
import pix4D from "./pix4D";
import schedules from "./schedules";
import itp from "./itp";

const orbModules = [
  modelViewer,
  assetManager,
  objectManager,
  itp,
  siteMaintenance,
  pix4D,
  schedules,
  pid,
];

export default orbModules;
